import $ from "jquery";
import "./_gsd.scss";
import JSZip from "jszip";

import select2 from "select2";
import "select2/dist/css/select2.css";
import "select2-bootstrap-theme/dist/select2-bootstrap.css";


// import the jquery plugin and initialize it
select2();

$(document).ready(() => {

  function fieldsetToggle(input, container) {
    container.querySelectorAll('input').forEach(childInput => {
      childInput.disabled = !input.checked
    });
    container.style.display = input.checked ? 'block' : 'none';
  }

  document.querySelectorAll(".fieldset-toggle").forEach(function(input) {
    // TODO copy all filled fields to new address fieldset

    const container = document.getElementById('fieldset-toggle.' + input.value);
    fieldsetToggle(input, container);
    input.addEventListener("change", function(event) {
      fieldsetToggle(event.target, container);
    });
  });

  const fileToUpload = document.getElementById('file-to-upload');
  const output = $('#folder-contents');
  const progress = $('#zip-progress');
  const submitButton = $('input[type="submit"][value="order"]');

  document.querySelectorAll("input[type='file']").forEach(input => {
    const maxFileSize = input.dataset['maxfilesize'];
    if (maxFileSize > 0) {
      input.addEventListener('change', function () {
        if (this.files[0].size > maxFileSize) {
          submitButton.attr('disabled', 'disabled');
          alert("Filesize Limit reached. Upload Limit is " + (maxFileSize * 0.000001).toFixed(2) + "MB")
          this.value = "";
        } else {
          submitButton.attr('disabled', undefined);
        }
      });
    }

    if (input.hasAttribute('webkitdirectory')) {

      const parentSelector = $(input).data("parent");
      const parent = $(parentSelector.replaceAll('.', "\\.")).get(0);
      let baseFolderName = 'folder-content';

      input.addEventListener('change', evt => {
        if (evt instanceof CustomEvent && evt.detail === 'nozip') {
          return;
        }
        submitButton.attr('disabled', 'disabled');
        output.empty();
        const zip = new JSZip();

        for (const file of evt.target.files) {
          let item = $("<li></li>");
          item.text(file.webkitRelativePath);
          output.append(item);
          zip.file(file.webkitRelativePath, file);

          if (file.webkitRelativePath) {
            baseFolderName = (file.webkitRelativePath.split('/')[0]);
          }
        }
        progress.text("Creating Zip File ...");

        zip.generateAsync({type: 'blob', compression: "DEFLATE"}, function (metadata) {
          progress.text(`Creating Zip File ... ${metadata.percent.toFixed(2)}%`)
        }).then(function (blob) {
          const zipFile = new File([blob], `${baseFolderName}.zip`);
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(zipFile);
          parent.files = dataTransfer.files;
          // safari fix
          if (parent.webkitEntries?.length) {
            parent.dataset.file = `${dataTransfer.files[0].name}`;
          }

          input.files = (new DataTransfer()).files;
          fileToUpload.innerText = `${baseFolderName}.zip`;
          submitButton.attr('disabled', undefined);
        })
      }, false);
    } else {
      input.addEventListener('change', evt => {
        fileToUpload.innerText = evt.target.files[0].name;
        output.empty();
        progress.empty();
      });
    }
  });

  $('.modal[role=dialog]').on('show.bs.modal', function (event) {
    const modal = $(this);
    $(modal).find('.loading').show();
    $(modal).find('.ajax-response').remove();
    $.ajax(event.relatedTarget.href)
      .done(data => {
         $(modal).find('.modal-body')
           .append($('<div class="ajax-response"></div>').append(data))

        var $subForm = $(modal).find('form');
         if ($subForm) {
           $subForm.on('submit', function () {
             modal.trigger('close');
           });
         }
      }).always(() => {
        $(modal).find('.loading').hide();
    });

    $('.mm-page').css('z-index', 'inherit');
  });
  $('.modal[role=dialog]').on('hide.bs.modal', function () {
    $('.mm-page').css('z-index', "");
  });

  $('[data-remote]').each(function () {
    var $this = $(this);
    var url = $this.data('remote');

    const optionTemplate = function (state) {
      if (!state.id) {
        return state.text;
      }
      return $(`<span style="display: inline-flex; align-items: center; flex-direction: row; flex-wrap: wrap;"><strong>${state.text}</strong><small>&nbsp;${state?.info ?? ''}</small></span>`)
    }

    // dataType: 'json' forces parsing regardless of the response's Content-Type
    // header (the backend serves this as text/html, so auto-detection would
    // otherwise leave `result` as a raw JSON string here)
    $.ajax(url, {dataType: 'json'})
      .done(function (result) {
        $this.select2({
          theme: 'bootstrap',
          width: '100%',
          tags: $this.data('tags') ?? false,
          data: result,
          templateSelection: optionTemplate,
          templateResult: optionTemplate,
          matcher(params, data){
            if ($.trim(params.term) === '') {
              return data;
            }

            if (typeof data.text === 'undefined') {
              return null;
            }

            if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1
              || data?.info?.toLowerCase().indexOf(params.term.toLowerCase()) > -1
            ) {
              return data;
            }

            return null;
          }
        })
      })
  });

  var counter = null;
  $('[data-copy-element]').click(function() {
    var $this = $(this);
    var $list = $($this.data('copy-list'));
    var $element = $($this.data('copy-element'));
    var countStart = $this.data('copy-count-start');
    var copyReplace = $this.data('copy-replace');

    if (counter === null) {
      counter = countStart;
    }
    console.log($element.get(0).innerHTML);
    console.log($element.get(0).innerHTML.replaceAll(copyReplace, counter));
    var $copy = $($element.get(0).innerHTML.replaceAll(copyReplace, counter));
    $list.append($copy);
    counter++;
  });

  $('body').on('click', '.inline-copy-element .button-remove', function (e){
    e.preventDefault();
    $(this).parents('.inline-copy-element').remove()
  });

});
